import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IRoutingRule } from './routingRule.interface';

export namespace RoutingRuleAction {
  const actionCreator = actionCreatorFactory('RoutingRule');

  export const reload = actionCreator('RELOAD');
  export const loadList = actionCreator.async<void, IRoutingRule[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IRoutingRule[], IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IRoutingRule[], IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
